import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConstantsService } from '../service/constants.service';

@Injectable({
  providedIn: 'root'
})
export class InvestigationService {

  
  constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

  updateinvestigation(updateObject) {
    return this.http.post(` ${this.constantsService.baseAPIURL}/eboi/investigation/saveInvestigation`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
      .pipe(
        catchError(this.handleError));
  }
  
  loadInvestigation(periodId): Observable<any> {//periodId {periodId}
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/investigation/getInvestigations/${periodId}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  getUsersDropDown(): Promise<any>{
    return this.http
			.get(`${this.constantsService.baseAPIURL}/eboi/getusers`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
  }

  rootcauseDropDown(pBlowout,pOWK): Promise<any>{
    return this.http
			.get(`${this.constantsService.baseAPIURL}/eboi/investigation/getRootCausesByBlowout/${pBlowout}/${pOWK}`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
  }

  counterMeasureDropDown(): Promise<any>{
    return this.http
			.get(`${this.constantsService.baseAPIURL}/eboi/getCounterMeasures`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
  }

  getPeriodsList(): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/getPeriods`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }


  private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}
